import { app_route_ids, app_route_keys } from "constants/urlPaths";
import { is_empty } from "features/Common/utils/common.utils";

export const MY_SUBSCRIPTION_RESPONSE_APIS = {
  [app_route_ids[app_route_keys.MY_SUBSCRIPTION]]: ({ listData }) => {
    const categories = {};
    for (let item of listData) {
      if (!is_empty(categories[item.category])) {
        categories[item.category].features.push(item);
      } else {
        categories[item.category] = {
          features: [item],
          category: item.category,
          category_icon: item.category_icon,
          id: item.category,
        };
      }
    }
    const response = Object.values(categories);
    return { data: !is_empty(response) ? response : [] };
  },
};
